import PropTypes from "prop-types";

export const TeamShape = PropTypes.shape({
  short: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  secondaryColor: PropTypes.string.isRequired,
});

// TODO XXX Placeholder colors: FF69B4, 800080
export const NFL_TEAMS = {
  NYJ: {
    short: "NYJ",
    name: "Jets",
    city: "New York",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  BUF: {
    short: "BUF",
    name: "Bills",
    city: "Buffalo",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  NE: {
    short: "NE",
    name: "Patriots",
    city: "New England",
    primaryColor: "#0D254C",
    secondaryColor: "#C80815",
  },
  MIA: {
    short: "MIA",
    name: "Dolphins",
    city: "Miami",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  CIN: {
    short: "CIN",
    name: "Bengals",
    city: "Cincinnati",
    primaryColor: "#FB4F14", // Orange
    secondaryColor: "#000000",
  },
  BAL: {
    short: "BAL",
    name: "Ravens",
    city: "Baltimore",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  PIT: {
    short: "PIT",
    name: "Steelers",
    city: "Pittsburgh",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  CLE: {
    short: "CLE",
    name: "Browns",
    city: "Cleveland",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  TEN: {
    short: "TEN",
    name: "Titans",
    city: "Tennessee",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  JAX: {
    short: "JAX",
    name: "Jaguars",
    city: "Jacksonville",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  HOU: {
    short: "HOU",
    name: "Texans",
    city: "Houston",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  IND: {
    short: "IND",
    name: "Colts",
    city: "Indianapolis",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  DEN: {
    short: "DEN",
    name: "Broncos",
    city: "Denver",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  KC: {
    short: "KC",
    name: "Chiefs",
    city: "Kansas City",
    primaryColor: "#E31837", // Red
    secondaryColor: "#FFB81C", // Yellow
  },
  LAC: {
    short: "LAC",
    name: "Chargers",
    city: "Los Angeles",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  OAK: {
    short: "OAK",
    name: "Raiders",
    city: "Oakland",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  DAL: {
    short: "DAL",
    name: "Cowboys",
    city: "Dallas",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  WAS: {
    short: "WAS",
    name: "Redskins",
    city: "Washington",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  PHI: {
    short: "PHI",
    name: "Eagles",
    city: "Philadelphia",
    primaryColor: "#004851",
    secondaryColor: "#000000",
  },
  NYG: {
    short: "NYG",
    name: "Giants",
    city: "New York",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  GB: {
    short: "GB",
    name: "Packers",
    city: "Green Bay",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  DET: {
    short: "DET",
    name: "Lions",
    city: "Detroit",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  MIN: {
    short: "MIN",
    name: "Vikings",
    city: "Minnesota",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  CHI: {
    short: "CHI",
    name: "Bears",
    city: "Chicago",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  ATL: {
    short: "ATL",
    name: "Falcons",
    city: "Atlanta",
    primaryColor: "#A6192D",
    secondaryColor: "#000000",
  },
  CAR: {
    short: "CAR",
    name: "Panthers",
    city: "Carolina",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  TB: {
    short: "TB",
    name: "Buccaneers",
    city: "Tampa Bay",
    primaryColor: "#D50A0A", // Red
    secondaryColor: "#34302B", // Pewter
  },
  NO: {
    short: "NO",
    name: "Saints",
    city: "New Orleans",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  ARI: {
    short: "ARI",
    name: "Cardinals",
    city: "Arizona",
    primaryColor: "#FF69B4",
    secondaryColor: "#800080",
  },
  SF: {
    short: "SF",
    name: "49ers",
    city: "San Francisco",
    primaryColor: "#AA0000", // Red
    secondaryColor: "#B3995D", // Gold
  },
  SEA: {
    short: "SEA",
    name: "Seahawks",
    city: "Seattle",
    primaryColor: "#69BE28", // "Action" green
    secondaryColor: "#002244", // Navy
    // Muted green is #046A38
  },
  LAR: {
    short: "LAR",
    name: "Rams",
    city: "Los Angeles",
    primaryColor: "#003594", // Blue
    secondaryColor: "#FFD100", // Yellow
    // primaryColor: "#002244", // Navy Blue
    // secondaryColor: "#866D4B", // Gold
  },
};



// WEBPACK FOOTER //
// ./src/nfl.js